import React from "react";
import styled from "styled-components";
import { device } from "../../../theme/device";

import { Link } from "react-router-dom";

// components
import Logo from "../../Navgation/Logo/Logo";
import NavigationItems from "../NavigationItems/NavigationItems";
import DrawerToggle from "../DrawerToggle/DrawerToggle";
import Newsletter from "../../Newsletter/Newsletter";
//import SubscriptionInput from "../SubscriptionInput/SubscriptionInput";

const ToolbarWrapper = styled.header`
  padding: 0 2rem;
  width: 100vw;
  //min-height: 9rem;
  background-color: white;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 110;
  box-sizing: border-box;

  @media (max-width: 700px) {
    justify-content: start;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: min-content;
    min-height: 5rem;
  }

  @media (max-width: 325px) {
    padding-top: 0rem;
    padding-left: 1rem;
    padding-right: 0rem;
    padding-bottom: 0rem;
    width: 105vw;
  }
`;

const StyledLogo = styled(Logo)`
  @media (max-width: 700px) {
    height: 4.5rem;
    margin: 1rem 0rem 0rem 0rem;
  }
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: baseline;

  @media (max-width: 700px) {
    justify-self: center;
  }
`;

const StyledNavigationItems = styled(NavigationItems)`
  @media (max-width: 701px) {
    display: none;
  }

  // @media ${device.phone} {
  //   display: none;
  // }
`;

const StyledNewsletter = styled(Newsletter)`
  align-items: baseline;
`;

const NewsletterContainer = styled.div`
  position: absolute;
  top: 6rem;
  right: 1rem;

  @media (max-width: 700px) {
    top: 3rem;
  }
`;

const Toolbar = props => {
  return (
    <ToolbarWrapper>
      <DrawerToggle clicked={props.drawerToggleClicked} />
      <StyledLink to="/">
        <StyledLogo />
      </StyledLink>
      <StyledNavigationItems />
      <NewsletterContainer>
        <StyledNewsletter />
      </NewsletterContainer>
      {/*<StyledNewsletter />*/}
      {/*<SubscriptionInput />*/}
    </ToolbarWrapper>
  );
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/Navgation/Toolbar/Toolbar.js